import op from 'object-path';
import navigation from './navigation';
import hardware from './hardware';
import api from './api';
import ui from './ui';

const events = {
  handlers: {},

  setup() {
    navigation.setup('navigation', this);
    hardware.setup('hardware', this);
    api.setup('api', this);
    ui.setup('ui', this);
  },

  emit(eventName, ...args) {
    if (!eventName) return;

    const handlers = op.get(this.handlers, eventName);
    if (!Array.isArray(handlers)) return;

    handlers.forEach(handler => {
      if (typeof handler !== 'function') return;

      handler(...args);
    });
  },

  on(eventName, handler, intercept = false) {
    if (!eventName || typeof handler !== 'function') {
      throw new Error('Invalid event name or handler');
    }

    const handlers = op.get(this.handlers, eventName);
    if (!Array.isArray(handlers) || intercept) {
      op.set(this.handlers, eventName, [handler]);
    } else {
      const index = handlers.findIndex(fn => fn === handler);
      if (index === -1) {
        handlers.push(handler);
      }
    }
  },

  off(eventName, handler) {
    if (!eventName || typeof handler !== 'function') {
      throw new Error('Invalid event name or handler');
    }

    const handlers = op.get(this.handlers, eventName);
    if (!Array.isArray(handlers) || handlers.length === 0) return;

    const index = handlers.findIndex(fn => fn === handler);
    if (index > -1) {
      handlers.splice(index, 1);
    }
  },

  once(eventName, handler) {
    const oneOff = (...args) => {
      handler(...args);
      this.off(eventName, oneOff);
    };
    this.on(eventName, oneOff);
  },

  intercept(eventName, handler) {
    this.on(eventName, handler, true);
  },
};

export default events;
